import { SchedulerLazyLoadingPlugin } from "../../internals/plugins/SchedulerLazyLoadingPlugin.mjs";
export class EventCalendarPremiumLazyLoadingPlugin extends SchedulerLazyLoadingPlugin {
  constructor(store) {
    super(store);
    store.registerStoreEffect(state => {
      const visibleDays = state.viewConfig?.visibleDaysSelector?.(state) ?? [];
      const visibleDaysKey = visibleDays.map(day => day.key).join('|');
      return {
        viewConfig: state.viewConfig,
        visibleDaysKey,
        isLoading: state.isLoading
      };
    }, (previous, next) => {
      if (previous.visibleDaysKey === next.visibleDaysKey) {
        return;
      }
      const visibleDays = next.viewConfig?.visibleDaysSelector?.(store.state) ?? [];
      if (!store.parameters.dataSource || visibleDays.length === 0) {
        return;
      }
      this.scheduleFetch(() => {
        const days = store.state.viewConfig?.visibleDaysSelector?.(store.state) ?? [];
        return {
          start: days[0].value,
          end: days[days.length - 1].value
        };
      }, previous.viewConfig == null);
    });
  }
}